export default __webpack_public_path__ + "static/media/symphony_sea.46c2d53d.mp3";